function getServerURL() {
  const localhost = 'http://localhost:3123'
  const staging = 'https://gamepasscbn-api.cloudxier.dev'
  const production = 'https://gamepasscbn-api.cloudxier.com'

  let host = window.location.host;
  if (host) {
    host = host.toLowerCase();
  }

  let env
  switch (host) {
    case 'gamepasscbn-admin.cloudxier.dev':
      env = staging
      break;
    case 'https://gamepasscbn-admin.cloudxier.dev':
      env = staging
      break;
    case 'gamepasscbn-admin.cloudxier.com':
      env = production
      break;
    case 'https://gamepasscbn-admin.cloudxier.com':
      env = production
      break;
    default:
      env = localhost
  }
  return env
};

export default getServerURL
